import data from './manual-rv-data.json.js';

const ManualRvData = data;

export { ManualRvData };
//# sourceMappingURL=manual-rv-data.js.map
